import { useState } from 'react'

import {
  ProductImageLineFragment,
  ProductImageSupplierFragment,
} from '@/graphql/purchase-plus/generated/purchasePlus_graphql'
import { ImageItem } from '@/modules/shared/components/image/ImageItem'
import ProductModal from '@/modules/shared/components/product-modal/ProductModal'
import { classNames } from '@/modules/shared/utils/classNames'

interface ProductImageProps {
  image: string
  clickToOpenModal?: boolean
  line?: ProductImageLineFragment | null
  supplier?: ProductImageSupplierFragment | null
}

export const ProductImage = ({ image, clickToOpenModal, line, supplier }: ProductImageProps) => {
  const [showProductDetailsModal, setShowProductDetailsModal] = useState<boolean>(false)
  return (
    <>
      <ImageItem
        src={image}
        alt={'product'}
        onClick={() => clickToOpenModal && setShowProductDetailsModal(true)}
        className={classNames('h-[3.75rem] w-[3.75rem] shrink-0 border border-gray-200', {
          'cursor-pointer': clickToOpenModal,
        })}
      />
      {line && line.product?.id && (
        <ProductModal
          showModal={showProductDetailsModal}
          setShowModal={setShowProductDetailsModal}
          line={line}
          supplier={supplier}
          productId={line.product?.id}
        />
      )}
    </>
  )
}
